export default __webpack_public_path__ + "static/media/user-check.1cb2765d.svg";